import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherIssueTypeId {
  ONLINE = 'online',
  PMS = 'pms',
}

export class GiftVoucherIssueType extends Codebook<GiftVoucherIssueTypeId> {
  static readonly ONLINE = new GiftVoucherIssueType(
    GiftVoucherIssueTypeId.ONLINE,
    () => $t('Online (Reservation+ form)'),
    () => $t('Online'),
  )
  static readonly PMS = new GiftVoucherIssueType(
    GiftVoucherIssueTypeId.PMS,
    () => $t('Manual (issued in PMS)'),
    () => $t('PMS'),
  )

  private constructor(
    public readonly value: GiftVoucherIssueTypeId,
    public readonly label: () => string,
    public readonly shortLabel: () => string,
  ) {
    super(value)
  }
}
